import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { UserRole } from "@/types/auth/role";

export const useAuthStore = defineStore("admin_auth", () => {
  const username = ref<string | null>(null);
  const userRole = ref<UserRole | null>(null);

  /**
   * 设置用户角色
   * @param role 用户角色
   */
  const setUserRole = (role: UserRole) => {
    userRole.value = role;
  };

  /**
   * 清除用户角色
   */
  const clearUserRole = () => {
    userRole.value = null;
  };

  /**
   * 检查用户是否为管理员
   * @returns 是否为管理员（ADMIN 或 SUPER_ADMIN）
   */
  const isAdmin = computed(() => {
    return userRole.value === UserRole.ADMIN || userRole.value === UserRole.SUPER_ADMIN;
  });

  /**
   * 检查用户是否为超级管理员
   * @returns 是否为超级管理员
   */
  const isSuperAdmin = computed(() => {
    return userRole.value === UserRole.SUPER_ADMIN;
  });

  /**
   * 清除所有用户信息
   */
  const clearUserInfo = () => {
    username.value = null;
    userRole.value = null;
  };

  return {
    username,
    userRole,
    setUserRole,
    clearUserRole,
    isAdmin,
    isSuperAdmin,
    clearUserInfo,
  };
}, {
  persist: {
    key: 'admin_auth',
    storage: localStorage,
    paths: ['username', 'userRole']
  }
});
